import { inject } from '@angular/core'
import { CanActivateFn, Router } from '@angular/router'
import { UserService } from '@/app/shared/services/user.service'

export const inventoryGuard: CanActivateFn = () => {
  const roles = inject(UserService).user()?.roles ?? []
  return roles.some((role) => ['GlobalAdmin', 'GlobalReader', 'CompanyAdmin', 'DivisionAdmin', 'profile_Admin', 'profile_StockManager', 'profile_ProcurementManager', 'profile_CPO', 'profile_InventoryController'].includes(role))
    || inject(Router).createUrlTree(['/requisitions'])
}
